import { ThunkDispatch } from 'store/store';
import { AnyAction, MiddlewareAPI } from 'redux';

import Services from 'store/Services';
import State from 'store/State';
import { actionIsPortfolioSetActiveInputAction } from 'portfolio/store/actions';
import { WidgetType } from 'widgets/WidgetType';
import { isBlotterSetSelectedRowIdsAction } from 'widgets/blotter/store/components/actions';
import { dispatchSetPortfolioSelectionIfChanged } from 'portfolio/store/middleware';
import { getBlotterPortfolioSelection } from 'widgets/blotter/BlotterPortfolioInput';

export const blotterPortfolioMiddleware = (services: Services) => [
    updatePortfolioSelectionOnBlotterBecomesActiveInput(services),
    updatePortfolioSelectionOnBlotterSelectedRowsChanged(services),
];

export function updatePortfolioSelectionOnBlotterBecomesActiveInput(
    services: Services
) {
    const { loggingService } = services;

    return (middlewareAPI: MiddlewareAPI<ThunkDispatch<AnyAction>, State>) =>
        (next: ThunkDispatch<AnyAction>) =>
        (action: AnyAction) => {
            // update the state
            next(action);

            if (!actionIsPortfolioSetActiveInputAction(action)) {
                return;
            }

            if (action.payload!.activeInputType !== 'Widget') {
                return;
            }

            if (
                action.payload!.activeInputWidget?.type !== WidgetType.BLOTTER
            ) {
                return;
            }

            loggingService.debug(
                'store: updatePortfolioSelectionOnBlotterBecomesActiveInput',
                'Selection changed required: blotter has become active input'
            );
            dispatchSelection(
                action.payload!.activeInputWidget.id,
                middlewareAPI,
                services
            );
        };
}

export function updatePortfolioSelectionOnBlotterSelectedRowsChanged(
    services: Services
) {
    const { loggingService } = services;

    return (middlewareAPI: MiddlewareAPI<ThunkDispatch<AnyAction>, State>) =>
        (next: ThunkDispatch<AnyAction>) =>
        (action: AnyAction) => {
            // update the state
            next(action);

            if (!isBlotterSetSelectedRowIdsAction(action)) {
                return;
            }

            loggingService.debug(
                'store: updatePortfolioSelectionOnBlotterSelectedRowsChanged',
                'Selection changed required: blotter selected rows have changed'
            );
            dispatchSelection(
                action.payload!.widgetKey,
                middlewareAPI,
                services
            );
        };
}

function dispatchSelection(
    widgetKey: string,
    middlewareAPI: MiddlewareAPI<ThunkDispatch<AnyAction>, State>,
    services: Services
) {
    const nextPortfolioSelection = getBlotterPortfolioSelection(
        widgetKey,
        middlewareAPI.getState()
    );
    dispatchSetPortfolioSelectionIfChanged(
        middlewareAPI,
        services,
        nextPortfolioSelection
    );
}
